/* playAdSelector.tsx */
import PlayTeadsHandler from './teads/playTeadsHandler';
import { AdSdkProvider } from '@shared/types/enums/ads';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { selectRoute } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import Pages from '@pages';

/**
 * PlayAdSelector component. Selects and displays a PauseAd.
 */
export default function PlayAdSelector() {
  const { pauseAd, playAd } = useAppSelector(adsSelector);
  const route = useAppSelector(selectRoute);
  /**
   * If not in a player based page or not active, return
   */
  if (![Pages.PLAYER, Pages.ZAPPER].includes(route.Page)) {
    return null;
  }
  /**
   * Select the appropriate ad handler based on the ad provider
   */
  switch (playAd?.sdkProvider) {
    case AdSdkProvider.TEADS:
      if (!playAd.placementId || !!pauseAd) return null;
      return <PlayTeadsHandler />;
    default:
      return null;
  }
}
